import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { BlockedInputDirective } from "../_directives/blocked-input.directive";
import { CanAccessBetaDirective } from "../_directives/can-access-beta.directive";

@NgModule({
	imports: [MaterialModule, CommonModule, HttpClientModule],
	declarations: [BlockedInputDirective, CanAccessBetaDirective],
	providers: [],
	exports: [CanAccessBetaDirective],
})
export class SharedModule {}
